import { create } from "zustand";

interface AppState {
  // Error state
  error: boolean | undefined;
  setError: (error: boolean | undefined) => void;

  // Form visibility state
  showForm: boolean;
  setShowForm: (show: boolean) => void;
  toggleForm: () => void;
}

export const useAppStore = create<AppState>((set) => ({
  // Error state
  error: undefined,
  setError: (error) => set({ error }),

  // Form visibility state
  showForm: false,
  setShowForm: (showForm) => set({ showForm }),
  toggleForm: () => set((state) => ({ showForm: !state.showForm })),
}));
